import {
  Button,
  TextField,
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
  Container,
  InputAdornment,
  makeStyles,
} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
//import { IsirScreenOptions } from "../../Utilities/Utility";
import { GroupAdd, ListAltOutlined, Visibility } from "@material-ui/icons";
import DescriptionIcon from "@material-ui/icons/Description";

//import "./Isirhm.scss";
import "./Isirhm.scss";
import { Link } from "react-router-dom";
//import AddIsir from "../AddIsir/AddSir";

//import AddIsir from "../AddlSir/AddlSir";
import AddIsir from "../ADDISIR/AddlSir";
import { IsirScreenOptions } from "../../Utilities/Utility";
//import cognisphere from "../../assets/images/HomePage-ImgNew.png
import "./../Home/Home.scss";
//port AddIcon from '@mui/icons-material/Add';

import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { custHeaderAction } from "../../Redux/Actions/actions";
import Cognisphere from "../../assets/images/HomePage-ImgNew.png";
import icon8D from "../../assets/images/8d_icon.png";
import iconDev from "../../assets/images/dev_icon.png";
import iconPdir from "../../assets/images/pdir_icon.png";
import iconAdmin from "../../assets/images/admin_icon.png";

const Isirhm = () => {
  const dispatch = useDispatch();

  const icons = {
    //"<ListAltOutlined />": <ListAltOutlined />,
    //"<DescriptionIcon />": <DescriptionIcon />,
    //"<GroupAdd />": <GroupAdd />,
    // Use the imported variables here
    /* "8D Tool": icon8D,*/
    "Development Tool": iconDev,

    //"Administrator": iconAdmin,
    //"Inprocess/PDIR": iconPdir // FIXED: Changed from <ListAltOutlined /> to your imported image
  };

  useEffect(() => {
   // dispatch(custHeaderAction("DEVELOPMENT TRACKER"));
  });

  return (
    <div className="main-component1">
      <p className="heading" style={{color:"white"}}>Welcome to Development Tracker</p>

      <Grid container className="Complaints-block" spacing={3}>
        {IsirScreenOptions.map((complaintItem) => (
          <Grid item xs={12} sm={4} key={complaintItem.complaintMenuId}>
            <Link
              to={complaintItem.complaintMenuLink}
              className="animated-menu-link"
            >
              <div className="tool-banner">
                <div className="icon-box">
                  {complaintItem.complaintIcon ? (
                    complaintItem.complaintIcon
                  ) : (
                    <div>No Icon</div>
                  )}
                </div>
                <div className="green-bar">
                  <span className="menu-label">
                    {complaintItem.complaintMenuName}
                  </span>
                </div>
              </div>
            </Link>
          </Grid>
        ))}
      </Grid>

      {/* <div className="bottom-decoration-wrapper">
        <img
          src={Cognisphere}
          alt="Process Flow"
          className="process-flow-img"
        />
      </div> */}
    </div>
  );
};
export default Isirhm;
